import { openNewWindow } from "../../../../../utils/common";
import { FranchiseBannerWrapper, FranchiseButton } from "./styles";

const HomeFranchiseBanner = () => {
  return (
    <FranchiseBannerWrapper>
      <img
        alt="가맹"
        className="tournament-back"
        src="https://runnerrunner-prd.s3.ap-northeast-2.amazonaws.com/home-banner/franchise-banner.png"
      />
      <div className="franchise-subtitle">NO.1 홀덤 브랜드 러너펍</div>
      <div className="franchise-title">전국 가맹 문의</div>
      <FranchiseButton>
        <div className="button" />
        <div
          className="button-text"
          onClick={() => {
            openNewWindow("https://www.xn--o39ak9ggzgc8bn87c.com/");
          }}
        >
          바로가기
        </div>
      </FranchiseButton>
    </FranchiseBannerWrapper>
  );
};

export default HomeFranchiseBanner;
